import { TYPED_ENV } from "@/utils/env";

export const resultsPageBase = TYPED_ENV.VITE_FRONT_BASE_URL;

export const groupedFooterLinks = [
  [
    { name: "Terms of Use", path: "https://skinnyrx.com/terms" },
    { name: "Privacy Policy", path: "https://skinnyrx.com/privacy" },
    { name: "Contact Us", path: "https://skinnyrx.com/contact" },
  ],
];

export const infoBannerLinks = [
  { name: "Protected Under Federal Law.", path: "#" },
];
